import React, { ReactNode, FC } from "react";
import "../styles/BottomOverlayStyles.css";
import closeIcon from "../assets/dashboardCloseIcon.png";
interface BottomOverlayProps {
  isOpen: boolean;
  onClose: () => void;
  children: ReactNode;
  cardWidth?: any;
  cardHeight?: any;
}

const CardBottomOverlay: FC<BottomOverlayProps> = ({
  isOpen,
  onClose,
  children,
  cardWidth,
  cardHeight,
}) => {
  if (!isOpen) return null;

  return (
    <div className="dashboarCardoverlay" onClick={onClose}>
      <div
        className="dashboarCardoverlay-content"
        style={{ maxWidth: cardWidth, minHeight: cardHeight }}
        onClick={(e) => e.stopPropagation()} // Prevent close when clicking inside
      >
        {/* <button className="dashboardoverlayclose-btn" onClick={onClose}>✕</button> */}
        <img
          className="dashboarCardoverlayClose-btn"
          src={closeIcon}
          onClick={onClose}
        />
        {children}
      </div>
    </div>
  );
};

export default CardBottomOverlay;
